import { ReactionCounter as BaseReactionCounter } from "@charkour/react-reactions"
import {
  ChatActions,
  MessageReactionCounts,
} from "@lazarentertainment/public-chat-web"
import styled from "styled-components"

import { ChatView } from "../../constants"

import { ChatReactionCounterButton } from "./ChatReactionCounterButton"

type ReactionCounterProps = {
  uiView: ChatView
}

// NOTE: We were unable to style this component without using !important
// overrides. In the future, we may wish to create an in-house reaction
// counter with more design flexibility.
const ReactionCounter = styled(BaseReactionCounter)<ReactionCounterProps>`
  border-radius: 15px;
  font-size: 13px;
  cursor: default !important;

  & div {
    box-shadow: none !important;
    width: auto !important;
    height: auto !important;
    z-index: unset !important;
    padding: 1px;
    margin: 0px 2px;
  }
`

export const ChatMessageReactionCounter = ({
  messageTimetoken,
  reactionCounts,
  toggleReaction,
  uiView,
}: {
  messageTimetoken: bigint | undefined
  reactionCounts?: MessageReactionCounts
  toggleReaction: ChatActions["toggleReaction"]
  uiView: ChatView
}) => {
  if (!reactionCounts) {
    return null
  }

  return (
    <ReactionCounter
      uiView={uiView}
      showReactsOnly
      reactions={Object.values(reactionCounts)
        .filter(({ count }) => count > 0)
        .map(
          ({
            reactionKey,
            count,
            sentActionTimetoken,
            optimisticState,
          }) => ({
            node: (
              <ChatReactionCounterButton
                onDarkBackground={uiView === ChatView.OVERLAY}
                selected={
                  (sentActionTimetoken !== undefined &&
                    optimisticState !== "removed") ||
                  optimisticState === "added"
                }
                onClick={() => {
                  if (messageTimetoken) {
                    toggleReaction(reactionKey, messageTimetoken)
                  }
                }}
                reactionKey={reactionKey}
                count={count}
              />
            ),
            label: reactionKey,
            by: null,
          }),
        )}
    />
  )
}
